import { openBlock as e, createElementBlock as c, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, n = /* @__PURE__ */ t("path", {
  "fill-rule": "evenodd",
  d: "M6.487 1.787a.75.75 0 1 0-1.438.426C6.139 5.888 7.602 9.37 10.775 12c-3.173 2.631-4.636 6.112-5.726 9.787a.75.75 0 1 0 1.438.426c.147-.496.3-.985.462-1.463H17.05c.162.479.315.967.462 1.463a.75.75 0 1 0 1.438-.426c-1.09-3.675-2.553-7.156-5.726-9.787 3.173-2.631 4.636-6.112 5.726-9.787a.75.75 0 0 0-1.438-.426c-.147.496-.3.984-.462 1.463H6.95a40.923 40.923 0 0 1-.462-1.463ZM16.499 19.25a18.929 18.929 0 0 0-1.222-2.517.758.758 0 0 1-.162.017H8.883a.751.751 0 0 1-.16-.017A18.925 18.925 0 0 0 7.5 19.25h9Zm-6.782-4h4.566A12.927 12.927 0 0 0 12 12.939c-.89.7-1.64 1.473-2.283 2.311ZM7.501 4.75H16.5c-.355.88-.754 1.721-1.221 2.517a.753.753 0 0 0-.161-.017H8.885a.753.753 0 0 0-.162.018A18.928 18.928 0 0 1 7.5 4.75Zm2.216 4h4.566A12.927 12.927 0 0 1 12 11.061c-.89-.7-1.64-1.473-2.283-2.311Z",
  "clip-rule": "evenodd"
}, null, -1), a = [
  n
];
function r(d, l) {
  return e(), c("svg", o, [...a]);
}
const h = { render: r };
export {
  h as default,
  r as render
};
